// 空占位，供别名映射使用
export default {} as any;

